import api from './api';

export const holidayApi = {
  // Get all holidays (optional year filter)
  getAll: (year) => {
    const params = year ? { year } : {};
    return api.get('/api/holidays', { params }).then(res => res.data);
  },
  
  // Get specific holiday by ID
  get: (id) => api.get(`/api/holidays/${id}`).then(res => res.data),
  
  // Create holiday (manager only)
  create: (data) => api.post('/api/holidays', data).then(res => res.data),
  
  // Update holiday (manager only)
  update: (id, data) => api.put(`/api/holidays/${id}`, data).then(res => res.data),
  
  // Delete holiday (manager only)
  delete: (id) => api.delete(`/api/holidays/${id}`).then(res => res.data)
};

export default holidayApi;

